export default __webpack_public_path__ + "static/media/unknown.f1ba9c3f.png";